import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import store from '@/store/index.js';

Vue.use(VueRouter)

const routes = [
  // {
  //   path: "/home",
  //   name: "Home",
  //   component: Home,
  // },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  {
    path: "/login",
    name: "Login",
    // component: () => import("../views/Login.vue"),
    component: () => import("../views/404.vue"),
  },
  {
    path: "/",
    name: "Dashboard",
    // component: () => import("../views/Dashboard.vue"),
    component: () => import("../views/404.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pending/:id/:time",
    name: "Pending",
    component: () => import("../views/Pending.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/timeout",
    name: "TimeOut",
    component: () => import("../views/TimeOut.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/overtime",
    name: "OverTime",
    component: () => import("../views/OverTime.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/warning/:message",
    name: "Warning",
    component: () => import("../views/Warning.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/exam/:id/:token",
  //   name: "Exam",
  //   component: () => import("../views/Exam.vue"),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/exam/:id",
    name: "Exam2",
    component: () => import("../views/Exam.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/preview",
    name: "GetPreviewExam",
    component: () => import("../views/GetToPreview.vue"),
    props: (route) => ({
      preview: { ...route.query }
    })
  },
  {
    path: "/lms",
    name: "GetShareTokenExam",
    component: () => import("../views/GetToPreview.vue"),
    props: (route) => ({
      sharetoken: { ...route.query }
    })
  },
  {
    path: "/preview/:id",
    name: "PreviewExam",
    component: () => import("../views/Exam.vue"),
  },
  {
    path: "/examlink",
    name: "Examlink",
    component: () => import("../views/ExamLink.vue"),
  },
  { 
    path: "*", 
    name: "NotFoundPage",
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//Global Guard
router.beforeEach((to, from, next) => {
  if(to.path != '/login') {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if(store.getters.isLoggedIn) { 
          next();
      } else {
          next('login');
      }
    } else if(to.path.substring(1).split('/')[0] == 'examlink') {
      next();
    } else if(to.path.substring(1).split('/')[0] == 'preview') {
      next();
    } else if(to.path.substring(1).split('/')[0] == 'NotFoundPage') {
      next();
    } else if (to.name == 'GetShareTokenExam') {
      next()
    }  else {
      next('login');
    }
  } else if(store.getters.isLoggedIn) { 
    next();
  } else {
    next();
  }
});

export default router
